import React, { useState, useEffect } from 'react';

const Checkbox = ({ label, checked = false, onChange }) => {
  const [isChecked, setIsChecked] = useState(checked);

  const handleToggle = () => {
    const newChecked = !isChecked;
    setIsChecked(newChecked);
    if (onChange) {
      onChange(newChecked);
    }
  };
useEffect(() => {
    setIsChecked(checked);
  }, [checked]);
  return (
    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleToggle}
        style={{ marginRight: '8px' }}
      />
      {label}
    </label>
  );
};

export default Checkbox;